var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { useColorModeValue, useTheme } from "@chakra-ui/system";
import { transparentize } from "../../core";
import { Size, Variant, ColorScheme, Spacing } from "../../core/constants";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, } from "../Modal";
import Text from "../Text";
import Button, { ButtonGroup } from "../Button";
/**
 * A simple dialog to mimic native `window.confirm` behavior.
 */
const ModalConfirm = (_a) => {
    var { className, titleText = "Confirm", confirmButtonText = "Yes", cancelButtonText = "No", variantColor, colorScheme, children, onClose, onConfirm } = _a, rest = __rest(_a, ["className", "titleText", "confirmButtonText", "cancelButtonText", "variantColor", "colorScheme", "children", "onClose", "onConfirm"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const theme = useTheme();
    const headerColor = useColorModeValue(`${scheme}.500`, transparentize(`${scheme}.500`, 0.75)(theme));
    return (React.createElement(Modal, Object.assign({}, rest, { onClose: onClose }),
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null,
                React.createElement(Text, { color: headerColor, colorScheme: undefined }, titleText)),
            React.createElement(ModalBody, null, children),
            React.createElement(ModalFooter, null,
                React.createElement(ButtonGroup, { spacing: Spacing[2] },
                    React.createElement(Button, { variant: Variant.solid, size: Size.md, colorScheme: ColorScheme.gray, onClick: onClose }, cancelButtonText),
                    React.createElement(Button, { variant: Variant.solid, size: Size.md, colorScheme: scheme, onClick: onConfirm }, confirmButtonText))))));
};
ModalConfirm.displayName = "ModalConfirm";
export default ModalConfirm;
//# sourceMappingURL=ModalConfirm.js.map